<template>
  <modal @close="closeModal" width="50%">
    <tabs slot="body" :options="tabsOptions" :cache-lifetime="0" ref="tabs">
      <tab id="supply-form" :name="title">
        <supply-form
          :supply="editedItem"
          :editedItem="editedItem"
          :families="families"
          :subFamilies="subFamilies"
          :mMeass="catalogs.unitMeasurements"
          :mSupplyType="catalogs.supplyTypes"
          :sFamily="sFamily"
          :family="family"
          :isRegister="isRegister"
          @saved="supplySaved"
        />
        <md-button class="md-info md-round" type="submit" form="item_form">
          Guardar
        </md-button>
      </tab>

      <tab id="camp-supply" name="Existencia en Campamento" v-if="!isRegister">
        <camp-supplies
          :highways="catalogs.highways"
          :providers="catalogs.providers"
          :supply="editedItem"
          :subFamilyId="sFamily"
        />
      </tab>
    </tabs>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import ErrorIndicator from "@/components/Validation/ErrorIndicator";
import { lazyComponent } from "@/utils";
import dataService from "@/services/catalog";
import SupplyForm from "./SupplyForm";

const CampSupplies = lazyComponent(() => import("./CampSupplies"));

export default {
  components: {
    ErrorIndicator,
    CampSupplies,
    SupplyForm,
  },

  props: {
    editedItem: Object,
    isRegister: Boolean,
    subFamilyId: {
      type: Number,
      default: 0,
    },
    familyId: {
      default: 0,
      type: Number,
    },
    defaultTab: {
      type: String,
      default: "supply-form",
    },
    catalogs: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  data() {
    const { editedItem } = this;
    return {
      updatedItem: {},
      family: 0,
      sFamily: 0,
    };
  },
  computed: {
    title() {
      const verb = this.editedItem.originalSupply
        ? "Crear variante de "
        : this.isRegister
        ? "Registrar"
        : "Editar";
      return `${verb} insumo`;
    },

    tabsOptions() {
      return { useUrlFragment: false, defaultTabHash: this.defaultTab };
    },

    ...mapState("catalogs", {
      subFamilies: (s) => s["services/subfamilies"],
      families: (s) => s["services/families"],
    }),
  },

  methods: {
    supplySaved(payload) {
      this.$emit("saved", payload);
    },

    closeModal: function () {
      this.$emit("close");
    },

    // Miscelanius methods
    consultMetas(ruta, asign, arg1, arg2) {
      // Make query for metaDatas
      let configuret;

      if (arg2) {
        configuret = {
          id: arg1,
          extraId: arg2,
          noStore: true,
          collection: true,
        };
      } else {
        configuret = { id: arg1, noStore: true };
      }
      dataService.fetch(ruta, configuret).then((res) => {
        this[asign] = res;
      });
    },
  },

  mounted() {},

  watch: {
    editedItem: {
      immediate: true,
      handler(newItem) {
        if (newItem) {
          this.family = newItem.familyId;
          this.sFamily = newItem.subFamilyId;
        }
      },
    },
    familyId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.family = value;
        }
      },
    },
    subFamilyId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.sFamily = value;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.md-content {
  max-width: 100%;
  max-height: 500px;
  overflow: auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.md-alignment-center {
  text-align: center;
}

.tabs-component {
  margin-top: 0em !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/SupplyModal.vue